import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import meetingReducer from "./api/meetingSlice"; // Import the meeting slice

// Set up the Redux store
export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer, // Add the API slice reducer
    meeting: meetingReducer, // Add the meeting slice reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware), // Add API slice middleware
});
